export default __webpack_public_path__ + "static/media/Impact ranking.36e25ca8.png";